import React, {} from 'react';
import {connect} from "react-redux";
import {setAbortController, setSQFTAr3dPopup} from "../../../../../actions/sqftMenuFunctions";
import ExportButton from "../../ar3d/ExportButton";
import SqftFeaturesPopup3dButtons from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopup3dButtons";
import SqftFeaturesPopupChangeColorButton from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopupChangeColorButton";
import SqftFeaturesPopupSaveImageButton from "../../../../popups/sqftFeaturesPopup/sqftFeaturesPopupSaveImageButton";
import Config from "../../../../../config";
import {setLookActiveCategory, setLookOpened} from "../../../../../actions/lookFunctions";
import {setAPIErrorMessage, setSqftCabinetsGlb} from "../../../../../actions/sqftFunctions";
import {isProd} from "../../../../../misc/fabricatorHardcode";
import ThreeDWorkspace from "../../../components/ar3d/ThreeDWorkspace";

const ThreeDContent = (props) => {
  const {setSQFTAr3dPopup} = props;

  const closeButtonClick = () => {
    setSQFTAr3dPopup(({isOpened: false, contentType: null}));
  }

  return (
    <div className="message-window-base ar-popup">
      <div className="">
        <button className="button--close"
                onClick={() => closeButtonClick()} >
        </button>
      </div>
      <div className="ar-popup__content">
        <ThreeDWorkspace/>
      </div>
      <div className="ar-popup__footer">
        <div className={"ar-popup__buttons"}>
          { Config.isDevMode() ? <ExportButton /> : null}
          { !isProd() ? <SqftFeaturesPopupChangeColorButton /> : null}
          <SqftFeaturesPopupSaveImageButton />
          <SqftFeaturesPopup3dButtons />
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  ar3dPopup: store.sqftMenuState.ar3dPopup,
  cabinetsGlb: store.sqftState.cabinetsGlb,
  apiErrorMessage: store.sqftState.apiErrorMessage,
  abortRequestController: store.sqftState.abortRequestController,
  lookActiveFeature: store.lookState.lookActiveFeature,
});

const mapDispatchToProps = {
  setSQFTAr3dPopup,
  setLookActiveCategory,
  setSqftCabinetsGlb,
  setAPIErrorMessage,
  setAbortController,
  setLookOpened,
};


export default connect(mapStateToProps, mapDispatchToProps)(ThreeDContent);
